import { render } from "./ManagePackages.vue?vue&type=template&id=9bc4747e&scoped=true"
import script from "./ManagePackages.vue?vue&type=script&lang=js"
export * from "./ManagePackages.vue?vue&type=script&lang=js"

import "./ManagePackages.vue?vue&type=style&index=0&id=9bc4747e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc4747e"]])

export default __exports__